import React, { useState } from "react";
import { Modal, Row, Col, Input, Button, DatePicker, Typography } from "antd";
import { createLinkSecurityData, updateLinkSecurityData } from "api/customApis";
import utils, { CheckboxContainer } from "./utils";
import moment from "moment-timezone";
const { Text } = Typography;

export default function LinkSettingsModal({
  handleUpdate,
  collectionLink,
  collectionId,
  visible,
  toggleModal,
  linkSecurityData,
  activateCatalogue,
  reactivateLinkSettings,
  collectionName,
}) {
  const linkSettingsId = linkSecurityData.id;
  const tempData = utils.setInitialdata(
    linkSecurityData.security_data,
    reactivateLinkSettings
  );
  const [data, setData] = useState(tempData);

  const [errorState, setError] = useState({});
  const onToggleCheckBox = (e) => {
    setData({
      ...data,
      [e.target.id]: e.target.checked,
    });
  };

  const handleDate = (key, value) => {
    const d = value.format("YYYY-MM-DD");
    const expiry = {
      ...data?.expiry,
      [key]: moment(d),
    };
    setData({
      ...data,
      expiry,
    });
  };

  const handelInputData = (e) => {
    setData({
      ...data,
      [e.target.id]: e.target.value,
    });
  };

  const handleNumberData = (e) => {
    const { value } = e.target;
    const reg = /^-?\d*(\d*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === "") {
      setData({
        ...data,
        [e.target.id]: value,
      });
    }
  };

  const validateDate = (expiry = {}) => {
    const todayDate = moment().format("YYYY-MM-DD");
    if (!expiry.to) {
      setError({ id: "setExpiry", message: "Select start and end date" });
      return false;
    }
    if (expiry.to.isBefore(todayDate)) {
      setError({ id: "setExpiry", message: "Past dates are not allowed" });
      return false;
    }

    // if (expiry.from > expiry.to) {
    //   setError({
    //     id: "setExpiry",
    //     message: "Start date should be greater than end date",
    //   });
    //   return false;
    // }
    return true;
  };

  const handleDone = () => {
    const todayDate = moment().format("YYYY-MM-DD");
    setError({});
    const finalData = {
      email: !!data.email,
    };
    if (data.setExpiry) {
      if (validateDate(data.expiry)) {
        finalData.expiry = {
          from: moment(todayDate),
          to: data?.expiry?.to,
          tz: moment.tz.guess(),
        };
      } else {
        return;
      }
    }

    if (data.setPasscode) {
      if (data.passcode && data?.passcode?.length === 6) {
        finalData.passcode = data.passcode;
      } else {
        setError({
          id: "setPasscode",
          message: "Enter a 6-digit passcode",
        });
        return;
      }
    }

    if (!linkSettingsId) {
      createLinkSecurityData(collectionLink, collectionId, finalData)
        .then((res1) => {
          const greyBoxData = utils.getGreyBoxData(finalData);
          handleUpdate(greyBoxData, {
            id: res1.data.id,
            security_data: res1.data.security_data,
          });
          toggleModal(false);
          if (reactivateLinkSettings) activateCatalogue(collectionId);
        })
        .catch((e) => {});
    } else {
      updateLinkSecurityData(linkSettingsId, finalData)
        .then((res2) => {
          const greyBoxData = utils.getGreyBoxData(finalData);

          handleUpdate(greyBoxData, {
            id: res2.data.id,
            security_data: res2.data.security_data,
          });
          toggleModal(false);
          if (reactivateLinkSettings) activateCatalogue(collectionId);
        })
        .catch((e) => {});
    }
  };

  const renderBody = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <CheckboxContainer
          id="email"
          value={data.email}
          onChange={onToggleCheckBox}
          label1="Email required to view catalogue"
          label2="Catalogue will only be visible once email id is entered"
        />

        <CheckboxContainer
          id="setExpiry"
          value={data.setExpiry}
          onChange={onToggleCheckBox}
          label1="Link expires on"
          label2="Link will be automatically deactivated after the selected date"
          errorState={errorState}
        >
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {/*            <DatePicker
              value={data?.expiry?.from}
              placeholder="Select start date"
              onChange={(date) => {
                handleDate("from", date);
              }}
              disabled={!data.setExpiry}
              style={{
                height:40,
                marginRight: "0.5rem",
                flexGrow: 1,
                border:
                  errorState.id === "setExpiry"
                    ? "1px solid red"
                    : "1px solid #d9d9d9",
              }}
            />*/}
            <DatePicker
              allowClear={false}
              value={data?.expiry?.to}
              placeholder="Set expiry date"
              onChange={(date) => {
                handleDate("to", date);
              }}
              disabled={!data.setExpiry}
              style={{
                height: 40,
                flexGrow: 1,
                border:
                  errorState.id === "setExpiry"
                    ? "1px solid red"
                    : "1px solid #d9d9d9",
              }}
            />
          </div>
        </CheckboxContainer>

        <CheckboxContainer
          id="setPasscode"
          value={data.setPasscode}
          onChange={onToggleCheckBox}
          label1="Passcode protect"
          label2="Add a 6-digit passcode to protect your catalogue"
          errorState={errorState}
        >
          <Input
            type="number"
            id="passcode"
            size="large"
            value={data.passcode}
            onChange={handleNumberData}
            placeholder="Enter 6-digit passcode"
            disabled={!data.setPasscode}
            style={{
              border:
                errorState.id === "setPasscode"
                  ? "1px solid red"
                  : "1px solid #d9d9d9",
            }}
          />
        </CheckboxContainer>
      </div>
    );
  };

  const renderButtons = () => {
    return (
      <Row justify="space-between" style={{ marginTop: "2rem" }}>
        <Col>
          <Button
            size="large"
            style={{
              backgroundColor: "white",
              color: "#4F5655",
              border: "1px solid #4F5655",
              width: 150,
            }}
            onClick={() => {
              toggleModal(false);
            }}
          >
            Cancel
          </Button>
        </Col>

        <Col>
          <Button
            size="large"
            style={{ width: 150, backgroundColor: "#1D2624", border: 0 }}
            htmlType="submit"
            type="primary"
            onClick={handleDone}
          >
            {reactivateLinkSettings ? "Activate" : "Update Settings"}
          </Button>{" "}
        </Col>
      </Row>
    );
  };

  return (
    <>
      <Modal
        visible={visible}
        onOk={() => {}}
        onCancel={() => toggleModal(false)}
        destroyOnClose={true}
        footer={null}
        width={600}
        bodyStyle={{ padding: "2rem" }}
        centered
      >
        <div style={{ marginBottom: "1.8rem" }}>
          <Row>
            <Text
              style={{
                marginBottom: "0.1rem",
                fontSize: 18,
                fontWeight: 800,
              }}
            >
              {reactivateLinkSettings
                ? "Reactivate catalogue link"
                : `Link security for ${collectionName}`}
            </Text>
          </Row>
          {reactivateLinkSettings && (
            <Row>
              <Text style={{ color: "#4F5655" }}>
                The link will be activated again and visitors can view the
                products
              </Text>
            </Row>
          )}
        </div>

        {renderBody()}
        {renderButtons()}
      </Modal>
    </>
  );
}
